<template>
    <div class="download" v-if="loggedIn">
        <el-dropdown placement="bottom-start" @command="handleDownload">
          <span class="el-dropdown-link">
            <i class="el-icon-download"></i> Pobierz <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="pdf">PDF</el-dropdown-item>
            <el-dropdown-item command="png">PNG</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Editor from '../../../classes/Editor'

export default {
    computed: {
        ...mapGetters('user', [
            'loggedIn',
        ]),
    },
    methods: {
        async handleDownload(type) {

            const loading = this.$loading({
                lock: true,
                text: `Pobieranie ${type}...`,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            try {
                switch (type) {
                    case 'pdf':
                        await Editor.getPdf()
                    break
                    case 'png':
                        await Editor.getPng()
                    break
                }
            } catch (error) {
                this.$alert(`Ups... Wystąpił błąd podczas pobierania ${type}`, 'Błąd pobierania')
            } finally {
                loading.close()
            }

        },
    },
}
</script>